export const TenantIcon = () => {
  return (
    <div style={{marginTop: '3px'}}>
      <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.75 21.5H2.25C1.00734 21.5 0 20.4927 0 19.25V2.75C0 1.50734 1.00734 0.5 2.25 0.5H21.75C22.9927 0.5 24 1.50734 24 2.75V19.25C24 20.4927 22.9927 21.5 21.75 21.5ZM6 4.625C4.96448 4.625 4.125 5.46448 4.125 6.5C4.125 7.53552 4.96448 8.375 6 8.375C7.03552 8.375 7.875 7.53552 7.875 6.5C7.875 5.46448 7.03552 4.625 6 4.625ZM6 9.125C4.96448 9.125 4.125 9.96448 4.125 11C4.125 12.0355 4.96448 12.875 6 12.875C7.03552 12.875 7.875 12.0355 7.875 11C7.875 9.96448 7.03552 9.125 6 9.125ZM6 13.625C4.96448 13.625 4.125 14.4645 4.125 15.5C4.125 16.5355 4.96448 17.375 6 17.375C7.03552 17.375 7.875 16.5355 7.875 15.5C7.875 14.4645 7.03552 13.625 6 13.625ZM19.5 7.25V5.75C19.5 5.43936 19.2481 5.1875 18.9375 5.1875H9.5625C9.25186 5.1875 9 5.43936 9 5.75V7.25C9 7.56064 9.25186 7.8125 9.5625 7.8125H18.9375C19.2481 7.8125 19.5 7.56064 19.5 7.25ZM19.5 11.75V10.25C19.5 9.93936 19.2481 9.6875 18.9375 9.6875H9.5625C9.25186 9.6875 9 9.93936 9 10.25V11.75C9 12.0606 9.25186 12.3125 9.5625 12.3125H18.9375C19.2481 12.3125 19.5 12.0606 19.5 11.75ZM19.5 16.25V14.75C19.5 14.4394 19.2481 14.1875 18.9375 14.1875H9.5625C9.25186 14.1875 9 14.4394 9 14.75V16.25C9 16.5606 9.25186 16.8125 9.5625 16.8125H18.9375C19.2481 16.8125 19.5 16.5606 19.5 16.25Z"
        fill="#F26E5F"
      />
    </svg>
    </div>
  );
};
